import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import { useStyle } from '~/providers/StyleProvider'

import { PRODUCT } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductSaveProps {
  className?: string
  value?: number
}

function ProductSave({ className, value }: ProductSaveProps) {
  const t = useTranslate()
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    color: GlobalThemeColors.DoveGray,
  })

  return (
    <p
      className={cx(className, css.ProductSave, textStyle)}
      dangerouslySetInnerHTML={{
        __html: t(PRODUCT.SETS_SAVE, {
          value,
          tag_start: '<span>',
          tag_end: '</span>',
        }),
      }}
    />
  )
}

export default ProductSave
